import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Tag,
  Rate,
  Avatar,
  Button,
  Dropdown,
} from "antd";
import {
  HeartOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const JobHeader = ({
  title,
  companyName,
  personnelCount,
  imageUrl,
  durationType,
  jobType,
  location,
  jobDuration,
  sector,
  department,
  position,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <Row gutter={8} align={"middle"}>
        <Col span={4}>
          <Avatar src={imageUrl} size={64} style={{ marginTop: 20 }} />
        </Col>
        <Col span={18}>
          <Title
            style={{
              textAlign: "start",
              justifyContent: "center",
              marginBottom: 0,
            }}
            level={4}>
            {title}
          </Title>
          <Title
            style={{
              textAlign: "start",
              marginTop: 0,
              justifyContent: "center",
            }}
            level={5}>
            {companyName}
          </Title>
          <Row>
            <Tag style={{ minWidth: 80, textAlign: "center" }}>
              {personnelCount + " Kişilik"}
            </Tag>
            <Tag style={{ minWidth: 80, textAlign: "center" }}>
              {durationType}
            </Tag>
            <Tag style={{ minWidth: 80, textAlign: "center" }}>{jobType}</Tag>
            <Tag style={{ minWidth: 80, textAlign: "center" }}>
              {jobDuration + " " + durationType}
            </Tag>
          </Row>
        </Col>
        {/* <Col span={2}>
          <Dropdown >
            <SettingOutlined />
          </Dropdown>
        </Col> */}
      </Row>
      <Row
        style={{
          marginTop: 20,
          borderTop: "1px solid #f0f0f0",
          padding: "12px 24px",
        }}
        gutter={[8, 25]}>
        <Col span={6}>
          <Text strong>Konum</Text>
          <br />
          <Text>{location}</Text>
        </Col>
        <Col span={6}>
          <Text strong>Sektör:</Text>
          <br />
          <Text>{sector}</Text>
        </Col>
        <Col span={6}>
          <Text strong>Departman:</Text>
          <br />
          <Text>{department}</Text>
        </Col>
        <Col span={6}>
          <Text strong>Pozisyon</Text>
          <br />
          <Text>{position}</Text>
        </Col>
      </Row>
    </div>
  );
};

export default JobHeader;
